import { Title } from '@gerdau/hefesto';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { sendTagging } from '../../../store/ducks/tagging/actions';
import { getTaggingInformationScreen } from '../../../utils/Tagging';
import { ContactInfo, Container } from './styles';

export const Contact: React.FC = () => {
  const dispatch = useDispatch();
  const { screenName = '', itemDescription = '' } = getTaggingInformationScreen(
    'help-center-contact'
  );

  const { pathname } = useLocation();

  const prepareAndSendTagging = (type: string) => {
    dispatch(
      sendTagging({
        screenName,
        itemDescription: `${itemDescription}${type}`,
        event: 'click'
      })
    );
  };

  useEffect(() => {
    dispatch(
      sendTagging({
        event: 'page_view',
        screenName,
        page: pathname
      })
    );
  }, []);

  return (
    <Container>
      <Title level={2}>Entrar em contato</Title>
      <p>
        Pensando na melhor experiencia para você, criamos esse canal para
        atendimento exclusivo caso queira nos enviar dúvidas, elogios ou
        sugestões.
      </p>
      <ContactInfo>
        <Title level={5}>Telefone:</Title>
        <a
          href="tel:+550800 722 3322"
          onClick={() => prepareAndSendTagging('telefone')}
        >
          0800 722 3322
        </a>
      </ContactInfo>
      <ContactInfo>
        <Title level={5}>Email:</Title>
        <u>
          <a
            target="_top"
            href="mailto:suportegerdaumais@gerdau.com.br"
            onClick={() => prepareAndSendTagging('email')}
          >
            suportegerdaumais@gerdau.com.br
          </a>
        </u>
      </ContactInfo>
      Envie sua dúvida, elogio ou sugestão através do email ou do número de
      telefone acima.
    </Container>
  );
};
